export type RenameDisplayNameError = 'empty' | 'path' | 'extension_missing' | 'extension_changed';

export function fileExtension(name: string): string {
  const trimmed = name.trim();
  const dot = trimmed.lastIndexOf('.');
  if (dot <= 0 || dot === trimmed.length - 1) return '';
  return trimmed.slice(dot + 1).toLowerCase();
}

export function displayNameStem(name: string): string {
  const trimmed = name.trim();
  const ext = fileExtension(trimmed);
  if (!ext) return trimmed;
  return trimmed.slice(0, trimmed.length - ext.length - 1);
}

/** Display-name rename: keep the current extension; do not change the storage path. */
export function validateRenamedDisplayName(
  next: string,
  current: string,
): RenameDisplayNameError | null {
  const trimmed = next.trim();
  if (!trimmed) return 'empty';
  if (/[\\/]/.test(trimmed) || trimmed.includes('\0')) return 'path';

  const currentExt = fileExtension(current);
  const nextExt = fileExtension(trimmed);
  if (currentExt) {
    if (!nextExt) return 'extension_missing';
    if (nextExt !== currentExt) return 'extension_changed';
  }
  return null;
}

export function localDateInputValue(date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function formatDocumentDate(value: string | null | undefined, locale?: string): string {
  if (!value) return '';
  const isoDay = value.length >= 10 ? value.slice(0, 10) : value;
  const parsed = new Date(`${isoDay}T12:00:00`);
  if (Number.isNaN(parsed.getTime())) return isoDay;
  return parsed.toLocaleDateString(locale);
}
